import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
} from "@mui/material";
import {
  Dashboard,
  DashboardIsActive,
  History,
  HistoryIsActive,
  Logout,
  LogoutIsActive,
  Notification,
  NotificationIsActive,
  Payment,
  PaymentIsActive,
  Profile,
  ProfileIsActive,
  RaiseComplaint,
  RaiseComplaintIsActive,
  Setting,
  SettingIsActive,
} from "Assets/SvgImage";
import ColorData from "Components/CstmTheme/ColorData";
import ImgPath from "Constants/Imgs";
import { RouteUrls } from "Constants/RouteUrls";
import { SIDEBAR_CONFIG } from "Constants/SidebarConfig";
import SidebarToggleButton from "./SidebarToggleButton";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import { useDispatch } from "react-redux";
import { clearUser } from "../../Redux/User/Action";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import {
  Dashboard as DashboardIcon,
  History as HistoryIcon,
  AddCircleOutline as CreateCaseIcon,
  AccountCircle as ProfileIcon,
  Payments as PaymentIcon,
  Stars as RewardIcon,
  ContactSupport as ComplaintIcon,
  ExitToApp as LogoutIcon,
  WhatsApp as WhatsAppIcon,
  Description as ContractIcon,
} from '@mui/icons-material';

import FeedbackIcon from '@mui/icons-material/Feedback';

export const navItems = [
  {
    label: "Home",
    inactiveIcon: <HomeIcon />,
    activeIcon: <HomeIcon />,
    path: "/home.html",
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER"],
  },
  {
    label: "Dashboard",
    inactiveIcon: <DashboardIcon />,
    activeIcon: <DashboardIcon />,
    path: RouteUrls.dashboard,
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER", "E_MITRA_USER"],
  },
  // {
  //   label: "Case Search",
  //   inactiveIcon: <ImgPath.CaseCreationIcon />,
  //   activeIcon: <ImgPath.CaseCreationIcon />,
  //   path: RouteUrls.caseSearch,
  //   roles: ["USER", "CORPORATEUSER", "NRIUSER", "ADMIN", "SUPERADMIN", "PROFESSIONAL"],
  // },
  {
    label: "Order History",
    inactiveIcon: <HistoryIcon />,
    activeIcon: <HistoryIcon />,
    path: RouteUrls.OrderHistory,
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER", "E_MITRA_USER"],
  },
  // {
  //   label: "e-Mitra Cases",
  //   inactiveIcon: <HistoryIcon sx={{ color: ColorData.text.secondary }} />,
  //   activeIcon: <HistoryIcon sx={{ color: ColorData.hover.main }} />,
  //   path: RouteUrls.eMitraCases,
  //   roles: ["ADMIN", "SUPERADMIN"],
  // },
  {
    label: "Create Case",
    inactiveIcon: <ImgPath.CaseCreationIcon />,
    activeIcon: <ImgPath.CaseCreationIcon />,
    path: RouteUrls.case,
    roles: ["USER", "CORPORATEUSER", "NRIUSER", "E_MITRA_USER"],
  },
  //Temp removed for ui
  // {
  //   label: "Smart Contracts",
  //   inactiveIcon: <ContractIcon />,
  //   activeIcon: <ContractIcon />,
  //   path: RouteUrls.contracts,
  //   roles: ["USER", "CORPORATEUSER", "NRIUSER", "PROFESSIONAL"],
  // },
  {
    label: "Profile",
    inactiveIcon: <ProfileIcon />,
    activeIcon: <ProfileIcon />,
    path: RouteUrls.userProfileForm,
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER", "E_MITRA_USER"],
  },
  {
    label: "Payment History",
    inactiveIcon: <PaymentIcon />,
    activeIcon: <PaymentIcon />,
    path: RouteUrls.PaymentHistory,
    roles: ["USER", "PROFESSIONAL", "ADMIN", "SUPERADMIN", "CORPORATEUSER", "NRIUSER", "E_MITRA_USER"],

  },
  {
    label: "Reward History",
    inactiveIcon: <RewardIcon />,
    activeIcon: <RewardIcon />,
    path: RouteUrls.RewardProgram,
    roles: ["USER", "CORPORATEUSER", "NRIUSER"],
  },
  {
    label: "Talk to NLP Executive",
    inactiveIcon: <ComplaintIcon />,
    activeIcon: <ComplaintIcon />,
    path: `${RouteUrls.chat}/admin-support`,
    roles: ["PROFESSIONAL", "CORPORATEUSER", "ADMIN", "SUPERADMIN", "E_MITRA_USER"], // Visible to Admin, SuperAdmin, and Professional
  },
  {
    label: "Raise Complaint",
    inactiveIcon: <ComplaintIcon />,
    activeIcon: <ComplaintIcon />,
    path: "https://nolegalpaisa.com/help-center.html",
  },
  // {
  //   label: "e-Mitra Users",
  //   inactiveIcon: <ProfileIcon sx={{ color: ColorData.text.secondary }} />,
  //   activeIcon: <ProfileIcon sx={{ color: ColorData.hover.main }} />,
  //   path: RouteUrls.eMitraUsers,
  //   roles: ["ADMIN", "SUPERADMIN"],
  // },
  {
    label: "My Payouts",
    inactiveIcon: <PaymentIcon sx={{ color: ColorData.text.secondary }} />,
    activeIcon: <PaymentIcon sx={{ color: ColorData.hover.main }} />,
    path: RouteUrls.eMitraPayouts,
    roles: ["E_MITRA_USER", "PROFESSIONAL"],
  },
  {
    label: "WhatsApp Dashboard",
    inactiveIcon: <WhatsAppIcon />,
    activeIcon: <WhatsAppIcon />,
    path: RouteUrls.whatsappDashboard,
    roles: ["SUPERADMIN"],
  },
  {
    label: "User Feedback",
    inactiveIcon: <FeedbackIcon />,
    activeIcon: <FeedbackIcon />,
    path: "/user-feedbacks",
    roles: ["SUPERADMIN"],
  },
  {
    label: "Logout",
    inactiveIcon: <LogoutIcon />,
    activeIcon: <LogoutIcon />,
    path: "/home.html",
  },
];

const Sidebar = ({
  drawerWidth,
  isCollapsed,
  onToggleCollapse,
  onClose,
  handleLogout,
}: {
  drawerWidth: number;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  onClose?: () => void;
  handleLogout?: () => void;
}) => {
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const currentUserType = myInfo?.userType;

  // Filter items based on the user's role
  const filteredNavItems = navItems.filter((item) => {
    // If roles are not defined, show to everyone by default
    if (!item.roles) return true;

    // Check if the current user's type is in the allowed roles array
    return item.roles.includes(currentUserType);
  });
  const [activeItem, setActiveItem] = useState("Dashboard");
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleItemClick = (label: string, path: string) => {
    if (label === "Logout") {
      localStorage.clear();
      dispatch(clearUser() as any);
      handleLogout?.();
      window.location.href = "/home.html";
    } else {
      setActiveItem(label);
      onClose?.();

      // If it's an external path or .html page, do full redirect
      if (path?.endsWith(".html") || path?.startsWith("http")) {
        window.location.href = path;
      } else {
        navigate(path);
      }
    }
  };

  return (
    <Box
      sx={{
        width: drawerWidth,
        height: "100vh",
        background: "linear-gradient(180deg, #283165 0%, #1c234b 100%)",
        px: isCollapsed ? 1 : 2.5,
        py: 3,
        position: "relative",
        transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
        display: "flex",
        flexDirection: "column",
        boxShadow: "10px 0 40px rgba(0,0,0,0.15)",
      }}
    >
      {/* Toggle Button */}
      <SidebarToggleButton
        isCollapsed={isCollapsed}
        onToggle={onToggleCollapse}
      />

      {/* Logo Section */}
      <Box
        display="flex"
        justifyContent={isCollapsed ? "center" : "start"}
        sx={{
          transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
          overflow: "hidden",
          flexShrink: 0,
          mb: 4,
          mt: 1,
          px: isCollapsed ? 0 : 2
        }}
      >
        {!isCollapsed ? (
          <img
            src={"https://nolegalpaisa.com/assets/images/new_logo.webp"}
            alt="Logo"
            style={{
              objectFit: "contain",
              width: "100%",
              maxWidth: 180,
              height: 50,
              transition: `all ${SIDEBAR_CONFIG.animationDuration}ms ease-in-out`,
              cursor: "pointer",
              // Remove filter if logo is already optimized or use a lighter one
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
            }}
            onClick={() => {
              window.location.href = "/home.html";
            }}
          />
        ) : (
          <Box
            sx={{
              width: 45,
              height: 45,
              background: "rgba(255,255,255,0.1)",
              backdropFilter: "blur(12px)",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.2rem",
              fontWeight: 900,
              color: "#ffffff",
              cursor: "pointer",
              border: "1px solid rgba(255,255,255,0.2)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                background: "rgba(255,255,255,0.2)",
                transform: "translateY(-2px)",
              }
            }}
            onClick={() => {
              window.location.href = "/home.html";
            }}
          >
            NP
          </Box>
        )}
      </Box>

      {/* Navigation List */}
      <List sx={{
        overflowY: "auto",
        flex: 1,
        mt: 2,
        minHeight: 0,
        px: 0.5,
        "&::-webkit-scrollbar": { width: 4 },
        "&::-webkit-scrollbar-thumb": {
          bgcolor: "rgba(255,255,255,0.1)",
          borderRadius: 10
        }
      }}>
        {filteredNavItems.map(({ label, inactiveIcon, activeIcon, path }) => {
          const isActive = label === activeItem;
          const isHovered = label === hoveredItem;

          const NavigationItem = (
            <ListItemButton
              key={label}
              onClick={() => handleItemClick(label, path)}
              onMouseEnter={() => setHoveredItem(label)}
              onMouseLeave={() => setHoveredItem(null)}
              sx={{
                borderRadius: "12px",
                mb: 1,
                mx: isCollapsed ? 0 : 0.5,
                px: isCollapsed ? 1 : 2,
                py: 1.5,
                minHeight: 52,
                justifyContent: isCollapsed ? "center" : "flex-start",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                bgcolor: isActive ? "rgba(255, 255, 255, 0.18)" : "transparent",
                border: isActive ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid transparent",
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: "20%",
                  height: "60%",
                  width: isActive ? "4px" : "0",
                  background: "linear-gradient(180deg, #ffffff 0%, #e2e8f0 100%)",
                  borderRadius: "0 4px 4px 0",
                  transition: "all 0.3s ease",
                },
                "&:hover": {
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  transform: isCollapsed ? "scale(1.08)" : "translateX(6px)",
                  "& .MuiListItemIcon-root": {
                    color: "#ffffff",
                    transform: "scale(1.1)",
                  }
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: isCollapsed ? "auto" : 40,
                  justifyContent: "center",
                  color: (isActive || isHovered) ? "#ffffff" : "rgba(255,255,255,0.6)",
                  transition: "all 0.2s ease",
                  "& .MuiSvgIcon-root": {
                    fontSize: "1.3rem",
                    filter: isActive ? "drop-shadow(0 0 8px rgba(255,255,255,0.4))" : "none",
                  }
                }}
              >
                {isActive || isHovered ? activeIcon : inactiveIcon}
              </ListItemIcon>

              {!isCollapsed && (
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        fontFamily: '"Outfit", sans-serif',
                        fontSize: "0.95rem",
                        fontWeight: isActive ? 700 : 500,
                        color: isActive ? "#ffffff" : "rgba(255,255,255,0.8)",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {label}
                    </Typography>
                  }
                />
              )}
            </ListItemButton>
          );

          // Wrap with Tooltip when collapsed
          return isCollapsed ? (
            <Tooltip key={label} title={label} placement="right" arrow>
              {NavigationItem}
            </Tooltip>
          ) : (
            NavigationItem
          );
        })}
      </List>
    </Box>
  );
};

export default Sidebar;
